import { render, staticRenderFns } from "./SubmittediInvoices.vue?vue&type=template&id=bb5561ee&"
import script from "./SubmittediInvoices.vue?vue&type=script&lang=js&"
export * from "./SubmittediInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports